module.exports = __webpack_public_path__ + "static/package-200d2b8082d23f48194c0610d2899e48.png";